import { useEffect } from 'react'
import { applyPageSeo, PageSeoProps } from '../lib/seo'

/**
 * Declarative component for setting page SEO, Social Meta, Canonical and JSON-LD schema
 *
 * Example usage:
 * <SeoHead
 *   title="Senior Software Architect Jobs"
 *   description="Find top verified engineering jobs in India..."
 *   canonicalPath="/jobs"
 * />
 */
export function SeoHead(props: PageSeoProps) {
  useEffect(() => {
    applyPageSeo(props)
  }, [
    props.title,
    props.description,
    props.canonicalPath,
    props.ogType,
    props.ogImage,
    props.noindex,
    JSON.stringify(props.jsonLd),
  ])

  return null
}
